import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { fmtErr } from "@/lib/api";
import { FolderPickerDialog } from "@/components/FolderPickerDialog";
import { useTranslation } from "react-i18next";

export function MoveDialog({ doc, folders = [], queryKey, onClose }) {
  const { t } = useTranslation();
  const qc = useQueryClient();

  const moveMut = useMutation({
    mutationFn: async (folder) => api.put(`/drive/files/${doc.id}/move`, { folder }),
    onSuccess: () => {
      toast.success(t("driveExplorer.fileMovedToast"));
      onClose();
      qc.invalidateQueries({ queryKey });
    },
    onError: (e) => toast.error(fmtErr(e)),
  });

  return (
    <FolderPickerDialog
      open={!!doc}
      title={`${t("common.move")} — ${doc?.filename || ""}`}
      folders={folders}
      initial={doc?.folder || ""}
      onSubmit={(folder) => moveMut.mutate(folder)}
      onClose={onClose}
      isPending={moveMut.isPending}
      testidPrefix="drive-move"
    />
  );
}
